export default __webpack_public_path__ + "media/images/react_icons/linkedin-74f15ddba45627c22b6c172a4cd3d271.svg";